import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';

import Button from '../components/Button';
import Form from '../components/Form';
import ProvidersShowcase from '../components/ProvidersShowcase';

function Home() {
  return (
    <Container fluid className="px-0 py-0">
      <Row style={{paddingTop: '4rem', paddingBottom: '4rem'}} className="g-0 mb-0 mb-md-5 h-100 bg-white">
        {/* Text Half */}
        <Col
          md={7}
          className="d-flex align-items-center justify-content-center "
        >
          <div className="px-3 px-md-5 py-4 w-100">
            <h1
              className="fw-bold mb-4"
              style={{ fontSize: "clamp(40px, 5vw, 64px)", lineHeight: 1.1 }}
            >SUBITE A TU NUEVA MOTO EN <span style={{color: 'var(--color-accent)'}}>CUOTAS FIJAS</span></h1>
            <p className="lead text-muted mb-4">Cargá tus datos y conocé al instante si calificás para una financiación personal. 100% Online.
Comparamos distintas opciones para ofrecerte la cuota que mejor se adapta a vos.</p>
            <Button
              onClick={() =>
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth",
                })
              }
              variant="danger"
              size="lg"
              className="d-inline-flex align-items-center gap-2"
            >
              <span>Calificate YA!</span>
              <FaArrowRight />
            </Button>
            <p className='mt-1 text-muted fst-italic'>Tus datos están protegidos</p>
            <ProvidersShowcase />
          </div>
        </Col>

        {/* Image Half */}
        <Col md={5} className="p-0 pe-md-5 d-flex align-items-center justify-content-center" >
          <div className="px-3 px-md-0 w-100">
            <img
              src="/home.svg"
              alt="Home"
              style={{
                width: "100%",
                maxWidth: "100%",
                borderRadius: "var(--radius-md)",
                boxShadow: "0 20px 45px rgba(15, 23, 42, 0.25)",
              }}
            />
          </div>
        </Col>
      </Row>
      <Form />
      <p className="text-muted text-center px-3 px-md-5">El monto indicado es orientativo y está sujeto a validación final por parte de la entidad financiera al momento de la solicitud.</p>
    </Container>
  );
}

export default Home;
